import AbstractComponent from "./abstract-component";
import {getFormattedPrice} from "../utils/get-formatted-price";


const createTemplate = ({title, link, imgSrc, isActive, countCart, price, oldPrice}) => {
  const inCart = +countCart > 0;

  const discountClass = isActive && +oldPrice > +price ? `preview-product__price--discount` : ``;

  return (
    `<article class="preview-product" title="${title}">
      <a class="preview-product__wrap" href="${link}" data-is-active="${isActive}">
        <h3 class="preview-product__title">${title}</h3>
        <p class="preview-product__image">
          <img class="" src="${imgSrc}" alt="${title}" loading="lazy">
        </p>

      ${isActive
      ? `<div class="preview-product__actionWrap" data-in-cart="${inCart}">
            ${oldPrice ? `<p class="preview-product__priceOld price">${getFormattedPrice(oldPrice)}</p>` : ``}
            <p class="preview-product__price ${discountClass} price">${getFormattedPrice(price)}</p>
            <button type="button" class="preview-product__cartButton" title="Добавить в корзину">Добавить в корзину</button>
            <button class="preview-product__cartLink" type="button">Оформить</button>
          </div>`
      : `<p class="preview-product__itemNotAvailable">Нет в наличии</p>`}

      </a>
        

  
    </article>`
  );
};

export default class ProductCardComponent extends AbstractComponent {
  constructor({data = ``}) {
    super();

    this._data = data;
  }

  getTemplate() {
    return createTemplate(this._data);
  }

  setCartButtonClickHandler(handler) {
    const button = this.getElement().querySelector(`.preview-product__cartButton`);

    if (!button) {
      return;
    }

    button.addEventListener(`click`, (evt) => {
      evt.preventDefault();
      handler(() => {
        this.getElement().querySelector(`.preview-product__actionWrap`).dataset.inCart = `true`;
      });
    });
  }

  setCartLinkButtonClickHandler(handler) {
    const button = this.getElement().querySelector(`.preview-product__cartLink`);

    if (!button) {
      return;
    }

    button.addEventListener(`click`, (evt) => {
      evt.preventDefault();
      handler();
    });
  }

  setErrorButtonsClickHandler(handler) {
    const buttons = this.getElement().querySelectorAll(`.product-list__itemLabelItemButton`);
    buttons.forEach((button) => {
      button.addEventListener(`click`, handler);
    });
  }
}
